import { ReactNode } from 'react';
import classNames from 'classnames';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Typography from '@lib/components/Typography/Typography';
import styles from './AiAssistant.module.scss';

type Props = {
  // A node, not just a string, so a caller mid-typewriter can trail a caret
  // inside the truncating label element.
  label: ReactNode;
  // Trailing control rendered after the label: an actions menu (message chip),
  // a remove button (composer chip), a loader (pending reference), or nothing
  // (unavailable placeholder).
  trailing?: ReactNode;
  // Muted styling for pending / unavailable references.
  muted?: boolean;
  className?: string;
};

// Shared visual shell for every document chip — the file icon + truncating
// label + an optional trailing control. InlineDocChip (message references) and
// ComposerDocChip (composer tokens) both render it so they stay visually
// identical; only the trailing control and behaviour differ.
function DocChip({ label, trailing, muted, className }: Props) {
  return (
    <span
      className={classNames(
        styles.docRefChip,
        {
          [styles.docRefChipMuted]: muted,
          [styles.docRefChipNoTrailing]: !trailing,
        },
        className,
      )}
    >
      <MaterialIcon
        icon="description"
        symbolsOutlined
        size="md-16"
        className={styles.docRefChipIcon}
      />
      <Typography variant="caption" className={styles.docRefChipLabel}>
        {label}
      </Typography>
      {trailing}
    </span>
  );
}

export default DocChip;
